import React from 'react';
import { Svg, ISvg } from '../../Svg';

export const AppStarter: React.FC<ISvg> = (props) => (
  <Svg viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.479 7.5781L15.093 3.1251C14.2262 2.39833 13.1312 2 12 2C10.8688 2 9.77379 2.39833 8.907 3.1251L3.521 7.5781C2.551 8.3811 2 9.59711 2 10.8661V17.8111C2 20.0661 3.734 22.0001 6 22.0001H8C8.53043 22.0001 9.03914 21.7894 9.41421 21.4143C9.78929 21.0392 10 20.5305 10 20.0001V16.7481C10 15.4801 10.952 14.5581 12 14.5581C13.048 14.5581 14 15.4801 14 16.7481V20.0001C14 20.5305 14.2107 21.0392 14.5858 21.4143C14.9609 21.7894 15.4696 22.0001 16 22.0001H18C20.266 22.0001 22 20.0661 22 17.8101V10.8661C22 9.59711 21.45 8.3811 20.479 7.5781Z"
      fill="white"
    />
  </Svg>
);
